import { useEffect } from 'react'
import { useViewStore } from '@/state/useViewStore'
import { now, nowInPrague } from '@/lib/clock'
import { isoWeekKey, monthKey, isFirstWorkingDayOfMonth } from '@/lib/workingDay'

export function TakeoverScheduler() {
  const viewMode = useViewStore((s) => s.viewMode)
  const setViewMode = useViewStore((s) => s.setViewMode)
  const weeklyShown = useViewStore((s) => s.weeklyShownForIsoWeek)
  const monthlyShown = useViewStore((s) => s.monthlyShownForMonth)
  const markWeeklyShown = useViewStore((s) => s.markWeeklyShown)

  useEffect(() => {
    const id = window.setInterval(() => {
      if (viewMode !== 'main') return
      const wall = nowInPrague()
      const h = wall.getHours()
      const inWindow = h >= 9 && h < 11
      if (!inWindow) return

      const today = now()
      const isMonday = wall.getDay() === 1
      const isFirstWorking = isFirstWorkingDayOfMonth(today)

      const mKey = monthKey(today)
      const wKey = isoWeekKey(today)

      if (isFirstWorking && monthlyShown !== mKey) {
        setViewMode('monthly')
        if (isMonday) markWeeklyShown(wKey)
        return
      }

      if (isMonday && weeklyShown !== wKey) {
        setViewMode('weekly')
      }
    }, 1000)
    return () => window.clearInterval(id)
  }, [viewMode, setViewMode, weeklyShown, monthlyShown, markWeeklyShown])

  return null
}
